import { sparksApi } from './createApi';

export const sparks = {
	list: async function( payload ) {
		const response = await sparksApi.post( '/list', payload );
		return response;
	},
};
